import React, { useState, useContext } from 'react';
import axios from 'axios';

import './styles.css';

import edit from '../../../assets/icons/edit.png';
import close from '../../../assets/icons/close.png';

import TextInput from '../../TextInput/TextInput';
import UserContext from "../../../contexts/UserContext";

function ProfileForm({
    cpf,
    name, setName, nameWarning, setNameWarning,
    email, setEmail, emailWarning, setEmailWarning,
    phone, setPhone, phoneWarning, setPhoneWarning,
}) {
    const { currentUser, setCurrentUser, accessToken } = useContext(UserContext);
    const [editable, setEditable] = useState(false);
    const handleClose = () => {
        setName(currentUser.nome);
        setEmail(currentUser.email);
        setPhone(currentUser.telefone);
        setEditable(false);
    }

    const saveProfile = () => {
        if (!name.length) setNameWarning('Este é um campo obrigatório');
        if (!email.length) setEmailWarning('Este é um campo obrigatório');
        if (!phone.length) setPhoneWarning('Este é um campo obrigatório');
        if (!name.length || nameWarning.length
            || !email.length || emailWarning.length
            || !phone.length || phoneWarning.length) {
            return;
        }

        const payload = {
            nome: name,
            email: email,
            telefone: phone,
        };

        axios.put(`${process.env.REACT_APP_API_URL}/client/me`, payload, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            })
            .then(() => {
                setCurrentUser({ ...currentUser, ...payload }, accessToken);
                setEditable(false);
            })
            .catch((err) => console.error(err));
    
    }

    return(
        <div className="profile-card">
            <div className="profile-form">
                <div className="profile-upper">
                    <p className="profile-title">Dados de cadastro</p>  
                    {
                        editable ?
                        <img src={close} alt="close-icon" className="profile-edit-icon" onClick={handleClose} />
                        :
                        <img src={edit} alt="edit-icon" className="profile-edit-icon" onClick={() => setEditable(true)} />
                    }
                </div>
                <div className="profile-form-row">
                    <TextInput label="CPF ou CNPJ" disabled value={cpf} black />
                </div>
                <div className="profile-form-line" />
                <TextInput
                    label="Nome"
                    value={name}
                    setValue={setName}
                    disabled={!editable}
                    warningMessage={nameWarning}
                    black
                />
                <div className="profile-form-row">
                    <TextInput
                        label="Email"
                        value={email}
                        setValue={setEmail}
                        disabled={!editable}
                        warningMessage={emailWarning}
                        black
                    />
                    <TextInput
                        label="Telefone"
                        value={phone}
                        setValue={setPhone}
                        disabled={!editable}
                        warningMessage={phoneWarning}
                        black
                    />
                </div>
                {
                    editable ?
                    <div className="profile-form-buttons-container">
                        <button className="profile-form-save-button" onClick={saveProfile}><p>Salvar</p></button>
                        <button className="profile-form-cancel-button" onClick={handleClose}><p>Cancelar</p></button>
                    </div>
                    : false
                }
            </div>
        </div>
    )
}

export default ProfileForm;